export const TOKEN_CONFIG = {
  Treasurenet: {
    tokens: [
      {
        symbol: 'UNIT',
        name: 'UNIT',
        icon: require('@/assets/image/exchange/unit.png'),
        decimals: 18
      },
      {
        symbol: 'TCASH',
        name: 'TCash',
        icon: require('@/assets/image/exchange/TCashIcon.png'),
        decimals: 18
      }
    ]
  },
  Ethereum: {
    tokens: [
      {
        symbol: 'WUNIT',
        name: 'WUNIT',
        icon: require('@/assets/image/exchange/unit.png'),
        decimals: 18,
        pairs: ['UNIT'] // target tokens
      },
      {
        symbol: 'WTCASH',
        name: 'WTCash',
        icon: require('@/assets/image/exchange/TCashIcon.png'),
        decimals: 18,
        pairs: ['TCASH']
      }
    ]
  }
}

// 获取代币对应关系
export const TOKEN_PAIRS = {
  'UNIT': {
    symbol: 'WUNIT',
    name: 'WUNIT',
    nameSelf: 'UNIT'
  },
  'WUNIT': {
    symbol: 'UNIT',
    name: 'UNIT',
    nameSelf: 'WUNIT'
  },
  'TCASH': {
    symbol: 'WTCASH',
    name: 'WTCash',
    nameSelf: 'TCash'
  },
  'WTCASH': {
    symbol: 'TCASH',
    name: 'TCash',
    nameSelf: 'WTCash'
  }
}
